export default __webpack_public_path__ + "static/media/googlePlay.bed76dae.png";